import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../Spinner/Spinner";
import GetAffonsoEmbedToken from "../../Services/GetAffonsoEmbedToken";
import { checkServiceResponse } from "../../Services/AuthService";
import styles from "./ReferAndEarn.module.css";

const ReferAndEarnPage = () => {
  const [publicToken, setPublicToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const fetchToken = useCallback(() => {
    setLoading(true);
    setError(false);
    GetAffonsoEmbedToken()
      .then((res) => {
        res.json().then((json) => {
          const checkServiceRes = checkServiceResponse(json, res);
          if (res.status !== 200) {
            if (checkServiceRes["pathname"]) {
              navigate(checkServiceRes.pathname);
            } else {
              setError(true);
            }
            setLoading(false);
            return;
          }
          setPublicToken(json.data.publicToken);
          setLoading(false);
        });
      })
      .catch((err) => {
        console.error(err);
        setError(true);
        setLoading(false);
      });
  }, [navigate]);

  useEffect(() => {
    fetchToken();
  }, [fetchToken]);

  if (loading) {
    return <Spinner />;
  }

  if (error || !publicToken) {
    return (
      <div className={styles["errorState"]}>
        <p>We couldn't load your Refer & Earn dashboard right now.</p>
        <button className={styles["retryButton"]} onClick={fetchToken}>
          Try again
        </button>
      </div>
    );
  }

  return (
    <div className={styles["wrapper"]}>
      <iframe
        className={styles["iframe"]}
        src={`https://affonso.io/embed/referrals?token=${publicToken}`}
        title="Refer & Earn"
        allow="clipboard-write"
      />
    </div>
  );
};

export default ReferAndEarnPage;
